import api from "../../dadosSolicitante/service/dadosSolicitante.service";
import { takeEvery, call, put, select } from "redux-saga/effects";
import formActions from "@common/store/form/form.actions";
import * as types from "./socio.actionType";
import socioActions from "./socio.actions";
import socioSelectors from "./socio.selectors";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.ADD_SAGA_SOCIO_LISTGRID, addSagaListSocio);
  yield takeEvery(types.SET_SAGA_SOCIO, setSagaSocio);
  yield takeEvery(types.SET_SAGA_PRINCIPAL_SOCIO, setSagaPrincipal);
  yield takeEvery(types.DELETE_SAGA_SOCIO_GRID, deleteSocioGrid);
  yield takeEvery(types.GET_SOLICITANTE, getSolicitante);
}

function* deleteSocioGrid(action) {
  const { payload } = action;
  const listState = yield select(socioSelectors.socio);

  let { listaSocio } = listState;
  let listaSocioArray = [...listaSocio];

  let newArray = listaSocioArray.filter(
    (x) => x.IdIdentificador != payload.IdIdentificador
  );

  if (payload.Principal == 1 && newArray.length > 0) {
    newArray[0] = { ...newArray[0], Principal: 1 };
  }

  yield put(socioActions.setStateListSocio(newArray));
  yield put(formActions.gridReload());
}

function* setSagaPrincipal(action) {
  const { payload } = action;
  const listState = yield select(socioSelectors.socio);
  let listNewPrincipal = listState.listaSocio.map((x) =>
    x.IdIdentificador == payload
      ? { ...x, Principal: 1 }
      : { ...x, Principal: 0 }
  );
  yield put(socioActions.setStateListSocio(listNewPrincipal));
  yield put(formActions.gridReload());
}

function* getSolicitante(action) {
  const { payload } = action;

  try {
    const result = yield call(api.getSolicitante, payload);

    const { data } = result;

    let socio = {
      CpfCnpj: payload,
      Nome: data.NomeSolicitante,
      Email: data.EmailSolicitante,
      RgIe: data.RgIeSolicitante,
      Telefone: data.TelefoneSolicitante,
      IdCcmSocio: data.IdCcmSocio,
      EnderecoSocio: {
        ...data.EnderecoSolicitante,
        Numero: data.Numero,
        Complemento: data.complemento,
      },
    };

    yield put(socioActions.setStateSocio(socio));
  } catch (e) {
    let socio = {
      CpfCnpj: undefined,
      Nome: undefined,
      Email: undefined,
      RgIe: undefined,
      TelefoneSolicitante: undefined,
      IdCcmSocio: undefined,
      EnderecoSocio: {},
    };
    yield put(socioActions.setStateSocio(socio));
  }
}

function* addSagaListSocio(action) {
  const { payload } = action;
  if (payload.DataEntrada > payload.DataSaida && payload.DataSaida) {
    _showError("Data da entrada não pode ser maior que a data da saída.");
  } else {
    const list = yield select(socioSelectors.socio);
    let max = 0;
    list.listaSocio.forEach((character) => {
      if (character.IdIdentificador > max) {
        max = character.IdIdentificador;
      }
    });
    let principal = list.listaSocio.length > 0 ? 0 : 1;

    if (payload.IdIdentificador != undefined) {
      let listEdit = list.listaSocio.map((x) =>
        x.IdIdentificador == payload.IdIdentificador
          ? {
              ...x,
              CpfCnpj: payload.CpfCnpj,
              Nome: payload.Nome,
              DataEntrada: payload.DataEntrada,
              DataSaida: payload.DataSaida,
              Email: payload.Email,
              Telefone: payload.Telefone,
              RgIe: payload.RgIe,
              IdCcmSocio: payload.IdCcmSocio,
              EnderecoSocio: payload.EnderecoSocio,
            }
          : x
      );
      yield put(socioActions.setStateListSocio(listEdit));
    } else {
      yield put(
        socioActions.addStateListSocio({
          IdIdentificador: max + 1,
          Principal: principal,
          CpfCnpj: payload.CpfCnpj,
          Nome: payload.Nome,
          DataEntrada: payload.DataEntrada,
          DataSaida: payload.DataSaida,
          Email: payload.Email,
          Telefone: payload.Telefone,
          RgIe: payload.RgIe,
          IdCcmSocio: payload.IdCcmSocio,
          EnderecoSocio: payload.EnderecoSocio,
        })
      );
    }
    yield put(formActions.gridReload());
    yield put(socioActions.closeModalSocio());
    yield put(socioActions.resetStateSocio());
  }
}

function* setSagaSocio(action) {
  const { payload } = action;
  yield put(
    socioActions.setStateSocio({
      IdIdentificador: payload.IdIdentificador,
      CpfCnpj: payload.CpfCnpj,
      Nome: payload.Nome,
      DataEntrada: payload.DataEntrada,
      DataSaida: payload.DataSaida,
      Email: payload.Email,
      Telefone: payload.Telefone,
      RgIe: payload.RgIe,
      IdCcmSocio: payload.IdCcmSocio,
      EnderecoSocio: payload.EnderecoSocio,
    })
  );
  yield put(socioActions.openModalSocio());
}
